import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Nav,
  TabContent,
  Input,
  TabPane,
  NavItem,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_GuestPassHistoryList,
  putAPI_GuestPassHistoryUpdate,
} from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import 'antd/dist/reset.css';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import Pagination from '../../../../../../containers/pages/Pagination';
import GuestsPassHistoryList from './GuestsPassHistoryList';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
.active{
  background-color:transparent;
}`;
function GuestPassHistory({ propertyId, locale, activeTab, toggleMenu }) {
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState({ column: 'Title', label: 'Title' });
  const [search, setSearch] = useState('');
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(25);
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const [historyList, setHistoryList] = useState([]);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  useEffect(() => {
    LoadData();
  }, [propertyId, currentPage, SelectedPageSize, search]);
  const LoadData = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_GuestPassHistoryList}?groupId=${getGroupID()}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}&propertyId=${propertyId}&lang=${locale}&orderBy=${orderBy.column
        }&search=${search}`,
    }).then((res) => {
      console.log(res.data);
      const sortedContacts = res.data?.historyList.sort((a, b) =>
        a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())
      );
      setTotalItems(res.data.totalItems);
      setTotalPages(res.data.totalPages);
      setHistoryList(sortedContacts);
      setLoading(false);
    });
  };
  const orderOptions = [
    { column: 'Title', label: 'Title' },
    { column: 'Type', label: 'Type' },
    { column: 'Response', label: 'Response' },
    { column: 'Status', label: 'Status' },
  ];

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };

  if (loading) {
    return <div className="loading" />;
  }

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  const onChangePage = (page) => setcurrentPage(page);
  const handleUpdate = (id) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_GuestPassHistoryUpdate}/${id}`,
    })
      .then((res) => {
        LoadData();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  return (
    <Fragment>
      <Row>
        <Colxx xxs="12" className="mb-3">
          <div className="mt-2">
            {/* <div className="d-block d-md-inline-block">
                  <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      <IntlMessages id="pages.orderby" />
                      {orderBy.label}
                    </DropdownToggle>
                    <DropdownMenu>
                      {orderOptions.map((order, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changeOrderBy(order.column)}
                          >
                            {order.label}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder="Search"
                      onKeyPress={(e) => onSearchKey(e)}
                    />
                  </div>
                  {!loading && (
                    <Fragment>
                      <div className="text-zero top-right-button-container ml-2">
                        <Button
                          color="primary"
                          size="xs"
                          outline
                          className="top-right-button mr-1"
                          onClick={toggleModal}
                        >
                          + Add Event
                        </Button>
                      </div>
                    </Fragment>
                  )}
                </div> */}
            <div className="float-md-right">
              <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
              <UncontrolledDropdown className="d-inline-block">
                <DropdownToggle caret color="outline-dark" size="xs">
                  {SelectedPageSize}
                </DropdownToggle>
                <DropdownMenu right>
                  {pageSizes.map((size, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => changePageSize(size)}
                      >
                        {size}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
            <div className="float-md-right mr-3">
              <div
                className="search-sm d-inline-block float-md-left mr-3 mb-1 align-top"
                style={{ width: '100%' }}
              >
                <Input
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search"
                  onKeyPress={(e) => onSearchKey(e)}
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          {historyList.length > 0 &&
            historyList.map((item, index) => (
              <GuestsPassHistoryList
                handleUpdate={handleUpdate}
                propertyId={propertyId}
                item={item}
              ></GuestsPassHistoryList>
            ))}
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          <Pagination
            currentPage={currentPage}
            totalPage={TotalPages}
            onChangePage={(i) => onChangePage(i)}
          />{' '}
        </Colxx>
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, domains } = settings;
  return {
    propertyId,
    locale,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps, {})(GuestPassHistory));
